import { Spinner } from '@creditornot/cb-progress';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

const Root = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const BootstrapInProgress = () => {
  return (
    <Root>
      <Spinner size="extraLarge" style={{ marginBlockEnd: '24px' }} />
      <T.Heading6 style={{ marginBlockEnd: '8px' }}>
        <FormattedMessage id="shared-menu.editor.empty-menu.bootstrap.in-progress.header" />
      </T.Heading6>
      <T.Body3>
        <FormattedMessage id="shared-menu.editor.empty-menu.bootstrap.in-progress.subheader" />
      </T.Body3>
    </Root>
  );
};
